// CsCenterMain.jsx
import React, { useState } from 'react';
import heroImage from '../../assets/imgs/csCenterHero.webp';

const sections = [
  {
    title: '제1조 (개인정보의 수집 및 이용 목적)',
    content: `
회사가 수집한 개인정보는 다음의 목적을 위해 활용합니다.

서비스 제공에 관한 계약 이행 및 서비스 제공에 따른 요금정산
콘텐츠 제공, 물품배송 또는 청구서 등 발송, 본인 인증 요금 결제, 요금추심

회원 관리
회원제 서비스 이용에 따른 본인 확인, 개인식별, 불량회원의 부정 이용 방지와 비인가 사용 방지, 가입 의사 확인, 가입 및 가입횟수 제한, 본 개정 이전에 가입한 14세 미만자의 법정 대리인 본인확인, 분쟁 조정을 위한 기록보존, 불만처리 등 민원처리, 고지사항 전달

마케팅 및 광고에 활용
이벤트 등 광고성 정보 전달
    `,
  },
  {
    title: '제2조 (개인정보 수집의 동의)',
    content: `
회사는 이용자에게 이용자 개인정보 수집에 대한 동의를 받고 있습니다. 회사 홈페이지 회원가입 절차 중 이용약관 및 개인정보수집 동의절차가 마련되어 있으며, 해당 절차의 이용자 동의를 근거로 하여 이용자 개인정보를 수집하고 있습니다. 이용자는 개인정보수집에 대해 동의하지 않을 경우 관련 서비스 제공 또는 회원가입이 제한될 수 있습니다.
    `,
  },
  {
    title: '제3조 (수집하는 개인정보 항목 및 수집방법)',
    content: `
회사는 회원가입, 상담, 서비스 신청 등을 위해 아래와 같은 개인정보를 수집하고 있습니다.

[수집하는 개인정보 항목]
필수 항목
이름, 로그인ID, 비밀번호, 휴대전화번호, 이메일, 회사명, 회사전화번호, 서비스 이용기록, 접속 로그, 접속 IP 정보, 결제기록, 사업자번호

서비스 이용 편의를 위해 회원이 자발적으로 아래와 같은 정보를 제공할 수 있습니다.
주소, 팩스번호, 전화번호, 영문 이름/영문 주소

서비스 이용이나 이벤트 응모, 기타 사업 처리 과정에서 아래와 같은 정보가 생성되어 수집될 수 있습니다.
실명, 성별, 생년월일, 직업, 회사명, 주소, 전화번호, 팩스번호, 영문 이름/영문 주소, 은행/신용카드 정보 등 결제수단 정보, 서비스 이용 기록, 접속 로그, 접속 IP 정보, 결제 기록, 불량 이용 기록, 방문 일시

[수집방법]
회사는 다음과 같은 방법으로 개인정보를 수집합니다.
홈페이지를 통한 회원가입, 상담 게시판, 서면 양식
서비스 이용에 따른 필수 정보 필요시 또는 이용자의 자발적 제공을 통한 수집
    `,
  },
  {
    title: '제4조 (개인정보의 보유 및 이용기간)',
    content: `
원칙적으로 개인정보의 보유 기간이 경과했거나 수집 및 이용 목적이 달성된 후에는 해당 정보를 지체없이 파기합니다.
단, 다음의 정보에 대해서는 아래의 이유로 명시한 기간동안 보존합니다.

회원탈퇴 시 보존 개인정보
보존항목: 회원이 제공한 이름, 사업자등록번호, 아이디, 이메일주소, 휴대전화번호 등
보존근거: 불량 이용자의 재가입 방지, 명예훼손 등 권리침해 분쟁 및 수사협조
보존기간: 회원탈퇴 후 1년

상법, 전자상거래등에서의 소비자보호에 관한 법률 등 관계법령의 규정에 의하여 보존할 필요가 있는 경우 회사는 관계법령에서 정한 일정한 기간 동안 회원정보를 보관합니다.

계약 또는 청약철회 등에 관한 기록
보존 이유: 전자상거래 등에서의 소비자보호에 관한 법률
보존 기간: 5년

대금결제 및 재화 등의 공급에 관한 기록
보존 이유: 전자상거래 등에서의 소비자보호에 관한 법률
보존 기간: 5년

소비자의 불만 또는 분쟁처리에 관한 기록
보존 이유: 전자상거래 등에서의 소비자보호에 관한 법률
보존 기간: 3년

방문에 관한 기록 (서비스 이용기록, 접속로그, 접속 IP 정보)
보존 이유: 통신비밀보호법
보존 기간: 3개월
    `,
  },
  {
    title: '제5조 (개인정보의 파기절차 및 방법)',
    content: `
파기절차
회원이 회원가입 등을 위해 입력한 정보는 목적이 달성된 후 내부 방침 및 기타 관련 법령에 의해서 별도의 DB로 옮겨져(종이의 경우 별도의 서류함) 일정 기간 저장된 후 파기됩니다. 개인정보는 법률에 의한 경우가 아니고는 보유되는 목적 이외의 다른 목적으로 이용되지 않습니다.

파기방법
종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기하고 전자적 파일형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다.
    `,
  },
  {
    title: '제6조 (개인정보의 제공 및 공유)',
    content: `
원칙적으로 회사는 회원의 개인정보를 수집 및 이용목적에 한해서만 이용하며 타인 또는 타기업/기관에 공개하지 않습니다.
다만, 아래의 경우에는 예외로 합니다.

이용자가 사전에 동의한 경우
정보수집 또는 정보제공 이전에 회원에게 비즈니스 파트너가 누구인지, 어떤 정보가 왜 필요한지, 언제까지 어떻게 보호/관리되는지 알리고 동의를 구하는 절차를 거치며, 회원이 동의하지 않는 경우에는 추가 정보를 수집하거나 비즈니스 파트너와 공유하지 않습니다.

법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우
정부기관이 해당 법률에서 정하는 소관업무를 수행하기 위하여 도메인 이름 및 네임서버 정보 등을 요청하는 경우
업무상 연락을 위하여 회원의 정보(성명, 주소, 전화번호)를 사용하는 경우
    `,
  },
  {
    title: '제7조 (개인정보 자동 수집 장치의 설치, 운영 및 거부에 관한 사항)',
    content: `
쿠키 등 인터넷 서비스 이용 시 자동 생성되는 개인정보를 수집하는 장치를 운영하지 않습니다.
    `,
  },
  {
    title: '제8조 (개인정보의 기술적·관리적·물리적 보호 대책)',
    content: `
회사는 이용자들의 개인정보를 처리함에 있어 개인정보가 분실, 도난, 누출, 변조 또는 훼손되지 않도록 안전성 확보를 위하여 다음과 같은 기술적/관리적/물리적 대책을 강구하고 있습니다.

[관리적 대책]
회사는 회사가 처리하는 개인정보의 안전한 관리를 위하여 내부관리계획을 수립하여 시행하고 있습니다.
회사는 회원의 개인정보를 암호화된 통신구간을 이용하여 전송하고 있으며, 상담 신청을 위해 별도의 이용자 ID와 비밀번호는 수집하지 않고 있습니다.
회사의 개인정보관련 처리 직원은 담당자에 한정시키고 있고 이를 위한 별도의 비밀번호를 부여하여 정기적으로 갱신하고 있으며, 담당자에 대한 수시 교육을 통하여 회사 개인정보처리방침의 준수를 항상 강조하고 있습니다.
사내 개인정보보호전담기구 등을 통하여 회사 개인정보처리방침의 이행사항 및 담당자의 준수여부를 확인하여 문제가 발견될 경우 즉시 수정하고 바로잡을 수 있도록 노력하고 있습니다. 단, 이용자 본인의 부주의나 인터넷상의 문제로 개인정보가 유출되어 발생한 문제에 대해 회사는 일체의 책임을 지지 않습니다.

[기술적 대책]
회사는 해킹이나 컴퓨터 바이러스 등에 의해 회원의 개인정보가 유출되거나 훼손되는 것을 막기 위해 최선을 다하고 있습니다. 개인정보의 훼손에 대비해서 자료를 수시로 백업하고 있고, 최신 백신프로그램을 이용하여 이용자들의 개인정보나 자료가 누출되거나 손상되지 않도록 방지하고 있으며, 암호화통신 등을 통하여 네트워크상에서 개인정보를 안전하게 전송할 수 있도록 하고 있습니다. 그리고 침입차단시스템을 이용하여 외부로부터의 무단 접근을 통제하고 있으며, 기타 시스템적으로 보안성을 확보하기 위한 가능한 모든 기술적 장치를 갖추려 노력하고 있습니다.

[물리적 대책]
개인정보를 보관하고 있는 전산실, 자료보관실 등 물리적 보관 장소에 대한 출입통제 절차를 수립하여 운영하고 있습니다.
개인정보가 포함된 서류, 보조저장매체 등을 잠금장치가 있는 안전한 장소에 보관하도록 지침을 마련하여 시행하고 있습니다.
    `,
  },
  {
    title: '제9조 (이용자 및 법정대리인의 권리와 그 행사방법)',
    content: `
이용자는 언제든지 등록되어 있는 자신의 개인정보를 조회하거나 수정할 수 있으며 가입해지를 요청할 수도 있습니다. 이용자의 개인정보 조회/수정을 위해서는 회사 홈페이지에 있는 '정보변경'을, 가입해지시에는 고객센터를 통해 탈퇴할 수 있습니다.
개인정보의 조회, 수정, 탈퇴, 처리정지 요구에 대해서는 10일 이내에 조치하여 처리 결과를 통지합니다.

회사는 이용자의 요청에 의해 해지 또는 삭제된 개인정보는 "회사가 수집하는 개인정보의 보유 및 이용기간"에 명시된 바에 따라 처리하고 그 외의 용도로 열람 또는 이용할 수 없도록 처리합니다.

[14세 미만 아동의 회원 가입에 대해]
㈜디엔에이클라우드는 만 14세 미만 아동의 회원가입은 받고 있지 않습니다.

[미성년자 거래시 철회에 대해]
회사는 미성년자와의 거래시 사전에 법정대리인(부모)의 동의를 구할 의무가 있으며, 법정대리인(부모)의 동의를 얻지 못한 거래는 취소할 수 있습니다. 또한 미성년자의 법정대리인(부모)이 거래 성립 후 7일 이내에 철회를 요청할 경우, 거래를 철회(환불)하겠습니다.
    `,
  },
  {
    title: '제10조 (개인정보 보호책임자 및 상담, 신고)',
    content: `
㈜디엔에이클라우드는 이용자의 개인정보 관련 문의사항 및 불만 처리 등을 위하여 아래와 같이 개인정보 관리 책임자 및 담당자를 지정하고 있습니다. 회원의 개인정보와 관련한 문의사항은 아래의 개인정보 보호책임자 또는 개인정보 보호담당자에게 연락하시기 바랍니다.

[개인정보보호 책임자]
- 담당부서: 기술팀
- 성명: 이봉로
- 전화: 010-6616-9138
- 이메일: brlee@dnacloud.co.kr

[개인정보보호 담당자]
- 담당부서: 기술팀
- 성명: 송인욱
- 전화: 010-3409-5589
- 이메일: iwsong@dnacloud.co.kr
    `,
  },
  {
    title: '제11조 (정보주체의 권익침해에 대한 구제방법)',
    content: `
정보주체는 아래의 기관에 개인정보 침해에 대한 피해구제, 상담 등을 문의할 수 있습니다.

- 개인정보침해신고센터: privacy.kisa.or.kr (국번없이 118)
- 개인정보분쟁조정위원회: kopico.go.kr (02-2100-2499)
- 대검찰청 사이버수사과: www.spo.go.kr (국번없이 1301)
- 경찰청 사이버안전국: ecrm.police.go.kr (국번없이 182)
    `,
  },
  {
    title: '제12조 (고지)',
    content: `
법령·정책 또는 보안기술의 변경에 따라 내용의 추가·삭제 및 수정이 있을 시에는 변경사항 시행일의 7일전부터 회사 사이트의 공지사항을 통하여 고지합니다. 단, 회원에게 불리한 내용이 포함된 경우, 변경사항 시행일의 30일전부터 고지합니다.

공고일: 2023년 04월 17일
시행일: 2023년 04월 17일
1차 개정일: 2025년 12월 31일
    `,
  },
];

function CsCenterMain({ firstSectionRef }) {
  // 폼 입력값 관리
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    subject: '',
    content: '',
    agreement: false, // 개인정보 동의
  });

  // input, textarea 변경 시
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const [activeIndex, setActiveIndex] = useState(null);

  const toggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  // 개인정보 동의 라디오 버튼 클릭 시
  const handleAgreement = (e) => {
    const agree = e.target.id === 'agree';
    setFormData((prev) => ({ ...prev, agreement: agree }));
  };

  // 제출 버튼 클릭 시
  const handleSubmit = async () => {
    const { name, phone, email, subject, content, agreement } = formData;

    // 간단한 유효성 체크
    if (!name || !phone || !email || !subject || !content) {
      alert('필수 입력값이 누락되었습니다.');
      return;
    }
    if (!agreement) {
      alert('개인정보 처리방침에 동의해야 합니다.');
      return;
    }

    try {
      // Nginx 프록시 경로("/sendEmail")로 POST 요청
      const response = await fetch('/sendEmail', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });
      const result = await response.json();

      if (response.ok) {
        alert('문의가 정상적으로 접수되었습니다. 감사합니다.');
        // 폼 초기화
        setFormData({
          name: '',
          phone: '',
          email: '',
          subject: '',
          content: '',
          agreement: false,
        });
      } else {
        alert('메일 전송 실패: ' + result.message);
      }
    } catch (err) {
      console.error(err);
      alert('서버 연결 실패 혹은 오류가 발생했습니다.');
    }
  };

  return (
    <div className="contactPageWrapper">
      <div ref={firstSectionRef} className="subHeroSection">
        <div className="heroItem flex-col align-center justify-center">
          <div className="subHeroImage">
            <img src={heroImage} alt="hero" />
          </div>
          <div className="grid flex-col justify-center align-center">
            <div className="flex-col gap-48 justify-center align-center">
              <div className="mainText">
                <span>고객센터</span>
              </div>
              <div className="description">
                <span>
                  다년간의 IDC 운영을 통해 축적한 노하우를 바탕으로, 전문가들이
                  1:1 상담해 드립니다.
                  <br />
                  다양한 문의방법과 지원 서비스를 제공해드리며, 언제든지 문의
                  주시면 친절히 답변해드리겠습니다.
                </span>
              </div>
              <div className="divide"></div>
            </div>
          </div>
        </div>
      </div>

      <div className="formSection py-96 flex-col align-center justify-center">
        <div className="grid flex-col gap-64">
          <div className="backBtnTitle">
            <div className="flex-row gap-8 align-center">
              <div className="iconWrap">
                {/* 아이콘 */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                >
                  <path
                    d="M6.66699 16H25.3337"
                    stroke="#232323"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M6.66699 16L14.667 24"
                    stroke="#232323"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M6.66699 16L14.667 8"
                    stroke="#232323"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <div className="text">
                <span>문의하기</span>
              </div>
            </div>
          </div>

          {/* 문의내용 작성 */}
          <div className="formPaperWrap tab:flex-col">
            <div className="formPaper tab:flex-col basicInfoForm flex-row align-start gap-40">
              <div className="titleWrap flex-col gap-24">
                <div className="main">
                  <span>문의내용 작성</span>
                </div>
                <div className="sub">
                  <span>상세한 작업내용 또는 궁금하신 사항을 적어주세요</span>
                </div>
              </div>
              <div className="formWrap tab:flex-full flex-col gap-24 py-32 px-20">
                {/* 작성자 */}
                <div className="basicInputWrap flex-col gap-8">
                  <div className="label">
                    <span>
                      <strong>*</strong>작성자
                    </span>
                  </div>
                  <div className="basicInput">
                    <input
                      type="text"
                      name="name"
                      placeholder="이름을 입력해주세요"
                      value={formData.name}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                {/* 연락처 */}
                <div className="basicInputWrap flex-col gap-8">
                  <div className="label">
                    <span>
                      <strong>*</strong>연락처
                    </span>
                  </div>
                  <div className="basicInput">
                    <input
                      type="text"
                      name="phone"
                      placeholder="010-0000-0000"
                      value={formData.phone}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                {/* 이메일 */}
                <div className="basicInputWrap flex-col gap-8">
                  <div className="label">
                    <span>
                      <strong>*</strong>이메일
                    </span>
                  </div>
                  <div className="basicInput">
                    <input
                      type="text"
                      name="email"
                      placeholder="user@sample.com"
                      value={formData.email}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                {/* 제목 */}
                <div className="basicInputWrap flex-col gap-8">
                  <div className="label">
                    <span>
                      <strong>*</strong>제목
                    </span>
                  </div>
                  <div className="basicInput">
                    <input
                      type="text"
                      name="subject"
                      placeholder="제목을 입력해주세요"
                      value={formData.subject}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                {/* 문의내용 */}
                <div className="textAreaInputWrap flex-col gap-8">
                  <div className="label">
                    <span>
                      <strong>*</strong>문의내용
                    </span>
                  </div>
                  <div className="textAreaInput">
                    <textarea
                      name="content"
                      cols="30"
                      rows="10"
                      placeholder="문의내용을 입력해주세요"
                      value={formData.content}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* 개인정보 처리방침 & 동의 */}
          <div className="formPaperWrap tab:flex-col flex-col gap-24">
            <div className="formPaper tab:flex-col submitForm flex-row align-start gap-40">
              <div className="titleWrap flex-col gap-24">
                <div className="main">
                  <span>개인정보 처리방침</span>
                </div>
                <div className="sub">
                  <span>
                    개인정보 처리방침에 동의에 완료 후 문의 접수가 가능합니다
                  </span>
                </div>
              </div>
              <div className="formWrap flex-col gap-24 py-32 px-20">
                {/* 개인정보 처리방침 내용 */}
                <div className="termWrap">
                  <span>
                    <span className={'pb-64'}>
                      ㈜디엔에이클라우드(이하 “회사”)은 「정보통신망 이용촉진 및
                      정보보호 등에 관한 법률」 등 모든 관련 법규를 준수하며,
                      회사의 서비스를 이용하는 고객(이하 “이용자”)의 개인정보가
                      보호받을 수 있도록 최선을 다하고 있습니다.
                      <br />
                      <br />
                      회사는 개인정보처리방침의 공개를 통하여 이용자의
                      개인정보가 어떠한 목적과 방식으로 이용되고 있으며
                      개인정보보호를 위해 어떠한 조치가 취해지고 있는지를 알려
                      드립니다.
                      <br />
                      <br />본 개인정보처리방침은 관련 법령의 개정이나 회사
                      내부방침에 의해 변경될 수 있으므로 회원 가입 시나 사이트
                      이용 시에 수시로 확인하여 주시기 바랍니다.
                    </span>
                    <div className="accoList flex-col">
                      {sections.map((section, index) => (
                        <div className="accordion" key={index}>
                          <div
                            style={{ fontWeight: 600 }}
                            className="accordion-header flex-row align-center justify-between  py-32"
                          >
                            <span>■ {section.title}</span>{' '}
                          </div>
                          <div
                            className={`px-16 accordion-content ${activeIndex === index ? 'open' : ''}`}
                          >
                            <span>{section.content}</span>
                          </div>
                        </div>
                      ))}
                    </div>
                  </span>
                </div>
              </div>
            </div>
            <div className="radioInputWrap flex-row align-center justify-end gap-32">
              <label htmlFor="agree" className="radioInput flex-row gap-4">
                <input
                  type="radio"
                  id="agree"
                  name="agreement"
                  checked={formData.agreement === true}
                  onChange={handleAgreement}
                />
                <div className="text">
                  <span>동의합니다</span>
                </div>
              </label>
              <label htmlFor="disagree" className="radioInput flex-row gap-4">
                <input
                  type="radio"
                  id="disagree"
                  name="agreement"
                  checked={formData.agreement === false}
                  onChange={handleAgreement}
                />
                <div className="text">
                  <span>동의하지 않습니다</span>
                </div>
              </label>
            </div>

            {/* 문의접수 버튼 */}
            <div className="submitBtnWrap flex-row align-center justify-end">
              <div
                className="headerContactUsBtn px-24 flex-row gap-8 align-center justify-center"
                onClick={handleSubmit}
                style={{ cursor: 'pointer' }}
              >
                <div className="textWrap flex-row gap-8 align-center">
                  <span>문의접수</span>
                </div>
                <div className="iconWrap ">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M6.32324 12H17.6263"
                      stroke="white"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M11.9746 6.34863L17.7356 12.0002L11.9746 17.6517"
                      stroke="white"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CsCenterMain;
